/**
 * @generated SignedSource<<7acb3b4921ab83447cb3b0cf28ef9458>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccounts_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutACHFormStripe_buyer" | "CheckoutACHForm_buyer" | "CheckoutBankAccountListWrapper_buyer" | "CheckoutWireTransferForm_buyer" | "checkoutPayment_buyer">;
  readonly " $fragmentType": "CheckoutBankAccounts_buyer";
};
export type CheckoutBankAccounts_buyer$key = {
  readonly " $data"?: CheckoutBankAccounts_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccounts_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccounts_buyer",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutPayment_buyer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Wallet",
          "kind": "LinkedField",
          "name": "wallet",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasCreditCards",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasBankAccounts",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutACHForm_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountListWrapper_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferForm_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutACHFormStripe_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1fdf6abf825bf3981dd388337730898a";

export default node;
